// 多多POS（DuoDuo POS）品牌常數。設計來源：tideverse/sites/duoduopos。
// 色票與 docs/superpowers/specs/2026-10-07-pos-app-expo-design.md §11.1 一致。
export const BRAND = {
  name: '多多POS',
  nameEn: 'DuoDuo POS',
  fullName: '多多POS DuoDuo POS',
};

export const COLORS = {
  canvas: '#FFFBEB',   // 頁面底色
  surface: '#FFFFFF',  // 卡片、面板
  ink: '#1C2D42',      // 標題、主要文字、主要按鈕、粗邊框
  inkDeep: '#0C1625',  // hover、厚底陰影
  muted: '#536073',    // 次要文字
  line: '#EADFC4',     // 分隔線
  accent: '#E8A317',   // 芥末黃：強調
  highlight: '#FFD35A',// 高亮黃：標籤、選取（配 ink 文字）
  warm: '#FFC857',     // 暖黃：小面積裝飾
  success: '#2F7D5B',  // 完成綠
  working: '#B8741A',  // 製作中琥珀
  danger: '#B30000',   // 作廢、刪除、錯誤
};

export const BRAND_ASSETS = {
  icon: '/brand/duoduopos-icon.svg',
  mark: '/brand/duoduopos-mark.svg',
  markDark: '/brand/duoduopos-mark-dark.svg',
  appleIcon: '/brand/apple-icon.png',
};
